<template>
    <div class="content">
        <center><h3>Hola soy el delete hotels</h3></center>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="">
    
</style>



// WEBPACK FOOTER //
// Delete.vue?1200a2d8